<template>
    <div>
		<div class="short_table_description table_description_filter">
			<div class="tertiary_color text_left">
				{{ $t("debtorManagement.overview.headTip") }}
			</div>
		</div>
        <div class="table_head table_head_filter">
            <div class="flex flex_between">
                <div>
					<md-button class="md-blank" @click="showDebtorSupplierBusinessRelationModal({})">
						{{ $t("debtorManagement.overview.addNewDebtor") }}
					</md-button>
                </div>
            </div>
        </div>
        <div class="flex filter_table">
            <div class="flex flex_column w_100">
                <ag-item
                        :rowData="rowData"
                        :columnDefs="columnDefs"
                        v-on:sortChanged="sortChanged"
                        :with-tabs="true"
                        :with-header="true"
						:with-short-description="true"
                ></ag-item>
                <Pagination
                        :totalNum="totalNum"
                        :pageSize="pageSize"
                        :sizeChange="sizeChange"
                        :currentChange="currentChange"
                        :currentPage="page"
                ></Pagination>
            </div>
			<DebtorOverviewFilter @apply-filter="applyFilter"/>
        </div>
        <DebtorSupplierBusinessRelationModal ref="relationModal" @change="getList"></DebtorSupplierBusinessRelationModal>
    </div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import Pagination from "src/components/templates/common/Pagination.vue";
import PaginationParent from "src/components/templates/common/PaginationParent.vue";

import {
	asDecimal,
	asLocalizedDate,
	asLocalizedNumberWithDays,
	asPercentage
} from "src/components/templates/agGrid/formatter/valueFormatters";
import {debtorManagementApi} from "src/common/api/debtorManagementApi";
import DebtorSupplierBusinessRelationModal
	from "src/components/templates/seller/debtorManagement/DebtorSupplierBusinessRelationModal";
import CofaceDraRenderer from "@/components/templates/agGrid/renderer/CofaceDraRenderer";
import {enumDef as enumDefs} from "@/common/enumDefs";
import DebtorOverviewFilter from "@/components/templates/seller/debtorManagement/DebtorOverviewFilter";

export default {
		extends: PaginationParent,
		components: { DebtorOverviewFilter, AgItem, Pagination, DebtorSupplierBusinessRelationModal},
		data() {
			return {
				rowData: [],
				columnDefs: [],
				gridApi: null,
				filters: [],
				sorting: [],
			};
		},
		beforeMount() {
			this.setColumnDefs();
			this.getList();
		},
		methods: {
			sortChanged(sortData) {
				this.sorting = sortData;
				this.initPage();
				this.getList();
			},
			setColumnDefs() {
				this.columnDefs = [
					{
						headerName: this.$t("common.debtor"),
						field: "debtorName",
						minWidth: 180,
						nameType: "debtorName",
						idType: "debtorId",
						cellRendererFramework: "CompanyTem",
						sortable: true,
					},
					{
						headerName: this.$t("common.cofaceDra"),
						headerComponentParams: {
							tooltip: this.$t("seller.sell.table.header.dra.tooltip"),
						},
						field: "cofaceDra",
						minWidth: 70,
						maxWidth: 70,
						cellRendererFramework: "CofaceDraRenderer",
						cellRendererParams: {
							draStatusField: "cofaceDraStatus"
						},
						sortable: true
					},
					{
						headerName: this.$t("common.country"),
						field: "debtorCountry",
						minWidth: 90,
                        maxWidth: 90,
						sortable: true,
					},
					{
						headerName: this.$t("common.applicableLaw.short"),
						field: "applicableLaw",
						minWidth: 110,
						sortable: true,
					},
					{
						headerName: this.$t("debtorManagement.overview.net"),
						field: "historicalPaymentDays",
						minWidth: 120,
						valueFormatter: asLocalizedNumberWithDays(),
						sortable: true
					},
					{
						headerName: this.$t("common.vatInPercent"),
						headerClass: "align-right",
						field: "vatRate",
						cellStyle: {'justify-content': 'flex-end'},
						minWidth: 75,
						valueFormatter: asPercentage({ default: "0,00%", showEmptyAsNotAvailable: true }),
						sortable: true
					},
					{
						headerName: this.$t("debtorManagement.overview.tciCreditScore"),
						headerComponentParams: {
							tooltip: this.$t("debtorManagement.overview.tciCreditScore.tooltip"),
						},
						headerClass: "align-right",
						field: "tciScore",
						cellStyle: {'justify-content': 'flex-end'},
						minWidth: 75,
						valueFormatter: asDecimal({ decimals: 0}),
						sortable: true
					},
					{
						headerName: this.$t("common.status"),
						field: "debtorState",
						minWidth: 150,
						maxWidth: 150,
						cellRendererFramework: "EnumAsText",
						enumDef: enumDefs.debtorState
					},
					{
						headerName: this.$t("common.lastUpdate"),
						headerComponentParams: {
							tooltip: this.$t("debtorManagement.overview.lastUpdate.tooltip"),
						},
						field: "updateTime",
						minWidth: 170,
						maxWidth: 170,
						valueFormatter: asLocalizedDate(),
						sortable: true
					},
					{
						headerName: this.$t("common.actions"),
						minWidth: 100,
						maxWidth: 100,
						cellRendererFramework: "DebtorOverviewTableOperation",
						cellRendererParams: {
							showDebtorDetails: this.showDebtorDetails,
							showDebtorContacts: this.showDebtorContacts,
							showCreditManagement: this.showCreditManagement,
							showDebtorDocuments: this.showDebtorDocuments,
						},
						pinned: "right"
					}

				];
			},
			getList() {
				let postData = {
					columns: [],
					filters: this.filters || [],
					maxResults: this.maxResults,
					offset: this.offset,
					sorting: this.sorting
				};
				debtorManagementApi.inspection
					.listBusinessRelation(postData)
					.then(res => {
						this.rowData = res.data;
						this.setTotalNum(res.recordsTotal);
					}).catch(this.toast);
			},
			applyFilter(filters) {
				this.filters = filters;
				this.getList();
			},
			showDebtorDetails(id) {
				this.$refs.relationModal.showDebtorDetails(id);
			},
			showDebtorContacts(id) {
				this.$refs.relationModal.showDebtorContacts(id);
			},
			showCreditManagement(id) {
				this.$refs.relationModal.showCreditManagement(id);
			},
			showDebtorDocuments(id) {
				this.$refs.relationModal.showDebtorDocuments(id);
			},
			showDebtorSupplierBusinessRelationModal(data) {
				this.$refs.relationModal.showRelationModal(data);
			},
		},
	};
</script>